import DriverManagementDashboard from '../../../../templates/js/components/Cards/DriverManagementDashboard.vue'
import SystemHealthMonitor from '../../../../templates/js/components/Cards/SystemHealthMonitor.vue'

const systemModuleSetup = app => {
  app.component('driver-management-dashboard', DriverManagementDashboard)
  app.component('system-health-monitor', SystemHealthMonitor)
}

export { systemModuleSetup }
